import { ApplicationConfig, inject, provideBrowserGlobalErrorListeners, APP_INITIALIZER, provideAppInitializer } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideTranslateService, TranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from "@ngx-translate/http-loader";
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideNgxMask } from 'ngx-mask';
import { authInterceptor } from './interceptors/auth.interceptor';
import { errorInterceptor } from './interceptors/error.interceptor';

import { routes } from './app.routes';
import { STORAGE_KEY } from './shared/data';

var initializeLanguage = () => {
  const translate = inject(TranslateService);
  const saved = localStorage.getItem(STORAGE_KEY);
  const lang = (saved === 'en' || saved === 'es') ? saved : 'es';
  translate.use(lang);
}


export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor, errorInterceptor])),
    provideTranslateService({
      loader: provideTranslateHttpLoader({
        prefix: '/assets/i18n/',
        suffix: '.json'
      }),
      fallbackLang: 'es',
      lang: 'es'
    }),
    provideNgxMask(),
    provideAppInitializer(initializeLanguage)
  ]
};
